module.exports = __webpack_public_path__ + "img/vrart_profile@2x.ad13c39b.jpg";